import { useTranslation } from "react-i18next";
import Text from "../../content/Text";
import Select from "../../form/Select";
import style from "../../../assets/scss/view/newAction.module.scss";
import { useEffect, useRef, useState } from "react";
import Load from "../Load";
import Button from "../../content/Button";
import arrowDownToLine from "@ingka/ssr-icon/paths/arrow-down-to-line";
import ArticleCard from "./ArticleCard";
import { Controller, useForm } from "react-hook-form";
import RequiredField from "../../form/RequiredField";
import useDateOptions from "../../../utils/useDateOptions";
import SearchUser from "../../form/SearchUser";
import { usePaOptions } from "../../../hooks/usePaOptions";
import { useArticles } from "../../../hooks/useArticles";
import { useFormValidation } from "../../../hooks/useFormValidation";
import { useEdsOptions } from "../../../hooks/useEdsOptions";
import CarouselTable from "../../content/CarouselTable";
import { useFlow } from "../../../hooks/useFlow";
import Message from "../../content/Message";
import TextArea from "../../form/TextArea";
import { getActions } from "../../../services/newActionServices";

export default function UtgNewAction({ flow, store, hfb, pcd, user, saveAction, loadingButton }) {
  const [t] = useTranslation("global")
  const [actions, setActions] = useState([])
  const [pa, setPa] = useState("null")
  const [searchArticleSelected, setSearchArticleSelected] = useState("null")
  const [order, setOrder] = useState({ label: "Calc.", value: "E" })
  const [edsClass, setEdsClass] = useState({
    value: "all",
    label: t("new-action.all-edsClass"),
  })
  const { optionsWeekStart, optionsWeekEnd } = useDateOptions()
  const [searchValue, setSearchValue] = useState('')
  
  // Custom hooks
  const { paOptions, loading } = usePaOptions({store, hfb, pcd})
  const { edsOptions, loading: loadingEdsOptions } = useEdsOptions({store, hfb, pcd})
  const { articles, articlesSelected, updateArticleSelected,updateArticleSelectedFromSearch, articlesToSelectFormatted, articlesRef, loadingArticles } = useArticles({pa, order, edsClass, pcd, flow, hfb, store, searchValue})
  const { start, end, responsible, contributor, DL, actionSelected, description, setStart, setEnd, setResponsible, setContributor, setDL, setActionSelected, setDescription, isFormValid } = useFormValidation(articlesSelected)

  const { handleSubmit, control } = useForm()
  const formRef = useRef()
  const {flow: flowData, isLoading} = useFlow()


  useEffect(() => {
    if(pa !== "null") setPa("null")
    
    if(searchArticleSelected !== "null") setSearchArticleSelected("null")
    
    if(searchValue !== '') setSearchValue('')

  }, [flow, store, hfb, pcd])

  useEffect(()=>{
      getActions({flow: flow.id}).then( actions => {
        setActions(actions.map( act => ({label: act.name, value: act.name})))
      })
    },[flow])

  const searchArticle = (newValue) => {
    if(pa !== 'null'){setPa('null')}
    if(newValue.length > 3){
      setSearchValue(newValue)
    }
  }

  const goToSaveAction = () => {
    const selectedItems = articles.filter(article => articlesSelected.includes(article.articleNumber)).map((i)=>({...i,item: i.articleNumber,iteminfo: i.itemInfoDTO }))
    const data = {
      flowid: flow.id,
      item: selectedItems,
      actiondl: DL,
      actionresponsible: responsible,
      actioncontributor: contributor,
      actionname: actionSelected,
      actiondescription: description,
      hfbid: hfb.id,
      storeid: store.id,
      statusact: "registro",
      actionregisteruserid: user,
      wkstartdate: start,
      wkenddate: end,
      files: []
    }
    saveAction(data)
  }

  const dateValue = (value) => optionsWeekEnd.find((o) => o.value === value)

  if(isLoading) return <Load />

  return (
    <>
      {flowData.head && 
        <Message
          style={{marginTop: '1.5rem'}}
          subtle
          body={<><Text
            headingSize="s">
              {flow?.name}
            </Text>
            <CarouselTable data={flowData.head} />
            </>
          }
          
        />
      }
      <hr/>
      <div className={style.container}>
        <Text tagName="h2" headingSize="m" className={style.stepTitle}>
          <span>1</span>
          {t("new-action.stepOne")}
        </Text>

        <div className="row" style={{ marginBottom: (pa === "null" && articlesSelected.length === 0) ? "9rem" : "0" }}>
          <div className="col-12 label-wrapper">
            <Select
              placeholder={t('components.select.searchArticle')}
              formField={{
                className: "col-12",
              }}
              label="Search"
              onInputChange={searchArticle}
              value={searchArticleSelected}
              onChange={(val)=>{
                updateArticleSelectedFromSearch(val)
                setSearchArticleSelected(val)
              }}
              isLoading={loadingArticles}
              options={pa === 'null' ? articlesToSelectFormatted : []}
              isSearchable={true}
              id="searchArticle"
            />
          </div>
          <Select
            formField={{ className: "col-12" }}
            options={paOptions}
            label="PA"
            value={pa}
            onChange={(pa)=>{
              setSearchArticleSelected("null")
              setSearchValue("")
              setPa(pa)
            }}
            id="pa"
          />
          <Select
            formField={{ className: "col-6" }}
            label={t("new-action.orderBy")}
            onChange={setOrder}
            id="orderBy"
            value={order}
            options={[
              { label: "Calc.", value: "E" },
              { label: t("global.units"), value: "U" },
            ]}
          />
          <Select
            formField={{ className: "col-6" }}
            label={t("new-action.edsClass")}
            onChange={setEdsClass}
            id="viewArticles"
            value={edsClass}
            options={edsOptions}
          />
        </div>

        {((loadingArticles && pa!== 'null') || loading || loadingEdsOptions) && <Load />}

        {(searchArticleSelected !== 'null' || pa !== 'null') && !loadingArticles && articles.length > 0 && (
          <div ref={articlesRef} className="pt-3 row">
            {pa !== 'null' && articles.map((article) => (
              <ArticleCard
                key={article.articleNumber}
                props={article}
                flow={flow}
                handleChange={updateArticleSelected}
              />
            ))}
            {searchArticleSelected !== 'null' && articles.filter((art)=>articlesSelected.includes(art.articleNumber)).map((article) => (
              <ArticleCard
                key={article.articleNumber}
                props={article}
                flow={flow}
              />
))}
            {articlesSelected.length > 0 && (
              <>
                <div ref={formRef}></div>
                <Button
                  type="emphasised"
                  iconOnly
                  size="small"
                  ssrIcon={arrowDownToLine}
                  className={style.buttonDown}
                  onClick={() =>
                    formRef.current.scrollIntoView({ behavior: "smooth", block: "start" })
                  }
                />
              </>
            )}
          </div>
        )}

        {/* Step Two */}
        {articlesSelected.length > 0 && (
          <form onSubmit={handleSubmit(goToSaveAction)}>
            <Text tagName="h2" headingSize="m" className={style.stepTitle}>
              <span>2</span>
              {t("new-action.stepTwo")}: {articlesSelected.join(", ")}
            </Text>
            <div className="row">
              <Controller
                                control={control}
                                name="actionType"
                                rules={{required: true }}
                                render={({ field:{value, onChange, ref}, fieldState: {error}}) => (
                                <Select
                                  formField={{
                                    className:"col-12",
                                    shouldValidate: error !== undefined,
                                    validation:{
                                      id:"error-msg-actionType",
                                      msg:t("validation.required"),
                                      type: "error"
                                    }
                                  }}
                                  label={<RequiredField text={t("new-action.actionType")}/>}
                                  value={actions.find((c) => c.value === value)}
                                  onChange={val => {
                                    onChange(val.value)
                                    setActionSelected(val.value)
                                  }}
                                  inputRef={ref}
                                  options={actions}
                                  id="actionType"
                                />
                                )} 
                              />
              <Controller
                control={control}
                name="startDate"
                rules={{ required: true }}
                render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
                  <Select
                    formField={{
                      className: "col-6",
                      shouldValidate: !!error,
                      validation: {
                        id: "error-msg-startDate",
                        msg: t("validation.required"),
                        type: "error",
                      },
                    }}
                    label={<RequiredField text={t("new-action.start")} />}
                    value={dateValue(value)}
                    onChange={(val) => {
                      onChange(val.value);
                      setStart(val.value);
                    }}
                    inputRef={ref}
                    options={optionsWeekStart}
                    id="startDate"
                  />
                )}
              />

              <Controller
                control={control}
                name="endDate"
                rules={{ required: true }}
                render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
                  <Select
                    formField={{
                      className: "col-6",
                      shouldValidate: !!error,
                      validation: {
                        id: "error-msg-endDate",
                        msg: t("validation.required"),
                        type: "error",
                      },
                    }}
                    label={<RequiredField text={t("new-action.end")} />}
                    value={dateValue(value)}
                    onChange={(val) => {
                      onChange(val.value);
                      setEnd(val.value);
                    }}
                    inputRef={ref}
                    options={optionsWeekEnd}
                    id="endDate"
                  />
                )}
              />

              <SearchUser control={control} name="responsible" setData={setResponsible} />
              <SearchUser control={control} name="contributor" setData={setContributor} />
              <SearchUser control={control} name="DL" setData={setDL} required={false} />
<Controller
                  control={control}
                  name="description"
                  rules={{maxLength: 1000, required: true }}
                  render={({ field:{ onChange, ref}, fieldState: {error}}) => (
                    <TextArea
                      formField={{
                        className:"col-12",
                        characterLimit:1000,
                        shouldValidate: error !== undefined,
                          validation:{
                            id:"error-msg-description",
                            msg:t("validation.maxLength"),
                            type: "error"
                          }
                      }}
                      textArea={{
                        label: <RequiredField text={t("new-action.description")}/>,
                        value: description,
                        onChange: e => {
                          onChange(e.target.value)
                          setDescription(e.target.value)
                        },
                      }}
                      inputRef={ref}
                    />
                  )} 
                />
              <Button
                className={!isFormValid ? style.submitButton : "col-12"}
                type="emphasised"
                text={t("new-action.save")}
                htmlType="submit"
                loading={loadingButton}
              />
            </div>
          </form>
        )}
      </div>
    </>
  )
}
